import Icon from '@material-ui/icons/History';
import List from './AdjustmentList';

export default {
    list: List,
    icon: Icon,
};
